import { render, staticRenderFns } from "./main.vue?vue&type=template&id=e953254e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=e953254e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e953254e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e953254e')) {
      api.createRecord('e953254e', component.options)
    } else {
      api.reload('e953254e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=e953254e&scoped=true", function () {
      api.rerender('e953254e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-application_method/main.vue"
export default component.exports